import { createAppAuthClient } from '@raas/cornerstone-auth/client';

export const {
  activateFirstOrganization,
  authClient,
  signIn,
  signOut,
  signUp,
  useSession,
} = createAppAuthClient();
